import InsurancePolicyPackageItem from '@advisory-report/src/features/creation-flow/components/insurance-policies/current-insurances/packages/InsurancePolicyPackageItem';
import { Icon, Button, useDisclosure } from '@wegroup/design-system';
import { InsurancePolicyPackage } from '@advisory-report/src/types/AdvisoryReport';
import { PartyType } from '@parties/src/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AnvaSimulationPackageEditModal from '@flows/src/pages/flow-products/AnvaSimulationPackageEditModal';

interface Props {
  pkg: InsurancePolicyPackage;
  sessionId: string;
  partyId: string;
  partyType: PartyType;
  editable?: boolean;
  withDocuments?: boolean;
}

const AnvaSimulationPackage: FC<Props> = ({
  pkg,
  sessionId,
  partyId,
  partyType,
  editable = true,
  withDocuments = false,
}) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <AnvaSimulationPackageEditModal
        partyId={partyId}
        isOpen={isOpen}
        onClose={onClose}
        sessionId={sessionId}
        pkg={pkg}
      />
      <InsurancePolicyPackageItem
        data={pkg}
        key={pkg.id}
        controlled
        partyType={partyType}
        withActions={false}
        withDocuments={withDocuments}
        customActions={
          editable && (
            <Button
              variant="white"
              onClick={onOpen}
              size="sm"
              leftIcon={<Icon name="GeneralActionsEditDocument" boxSize="5" />}
            >
              {t('EDIT')}
            </Button>
          )
        }
        partyId={partyId}
      />
    </>
  );
};

export default AnvaSimulationPackage;
